import { render } from "./AiUsageInfo.vue?vue&type=template&id=6fe7f910&scoped=true"
import script from "./AiUsageInfo.vue?vue&type=script&lang=js"
export * from "./AiUsageInfo.vue?vue&type=script&lang=js"

import "./AiUsageInfo.vue?vue&type=style&index=0&id=6fe7f910&scoped=true&lang=css"
import "./AiUsageInfo.vue?vue&type=style&index=1&id=6fe7f910&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe7f910"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
